import { z } from 'zod';
export const communicationsCustomerPortalProjectIntakeSubmittedEventName = 'customer-portal.project-intake-submitted.v1';
export const communicationsTrainingAssessmentResultEventName = 'training.assessment-result-notification-requested.v1';
export const communicationsWorkforceProtectedFormNotificationEventName = 'documents.workforce-protected-form-notification-requested.v1';
export const communicationsKnowledgeSignedPolicyCopyNotificationEventName = 'documents.knowledge-signed-policy-copy-notification-requested.v1';
export const communicationsSystemNotificationAdapterSourceModule = 'communications';
export const communicationsSystemNotificationAdapterSourceEventVersion = 1;
export const communicationsSystemNotificationAdapterKindSchema = z.enum([
    'customer-portal-intake',
    'training-assessment-result',
    'workforce-protected-form',
    'knowledge-signed-policy-copy',
]);
export const communicationsSystemNotificationAdapterPresentation = {
    'customer-portal-intake': {
        sourceKind: 'customer-portal-intake',
        title: 'Project intake submitted',
        body: 'A customer Project intake is ready for review.',
        actionPath: '/projects/',
    },
    'training-assessment-result': {
        sourceKind: 'training-assessment-result',
        title: 'Training assessment result',
        body: 'A training assessment result is available for review.',
        actionPath: '/training/grades',
    },
    'workforce-protected-form': {
        sourceKind: 'workforce-protected-form',
        title: 'Employee form submitted',
        body: 'A protected employee form is available in Documents.',
        actionPath: '/documents/employee-forms',
    },
    'knowledge-signed-policy-copy': {
        sourceKind: 'knowledge-signed-policy-copy',
        title: 'Signed policy copy available',
        body: 'Your signed policy copy is available in Documents.',
        actionPath: '/documents/signed-policies',
    },
};
export const communicationsPlatformSystemNotificationEnqueueResultSchema = z.strictObject({
    request_id: z.string().uuid(),
    outbox_event_id: z.string().uuid(),
    inserted: z.boolean(),
});
const timestampWithOffsetPattern = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,6}))?(Z|[+-]\d{2}:\d{2})$/;
/** Compare PostgreSQL TIMESTAMPTZ values without JavaScript millisecond truncation. */
export function samePostgresMicrosecondInstant(left, right) {
    const parse = (value) => {
        const matched = timestampWithOffsetPattern.exec(value);
        if (matched === null)
            throw new Error('Expected an ISO timestamp with at most six fractional digits.');
        const [, yearText, monthText, dayText, hourText, minuteText, secondText, fraction = '', offset] = matched;
        if (offset === undefined)
            throw new Error('Expected an ISO timestamp offset.');
        const year = Number(yearText);
        const month = Number(monthText);
        const day = Number(dayText);
        const hour = Number(hourText);
        const minute = Number(minuteText);
        const second = Number(secondText);
        const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
        const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        const monthDays = days[month - 1];
        if (year < 1 || monthDays === undefined || day < 1 || day > monthDays || hour > 23 || minute > 59 || second > 59) {
            throw new Error('Expected a valid ISO calendar timestamp.');
        }
        const years = BigInt(year - 1);
        const beforeYear = years * 365n + years / 4n - years / 100n + years / 400n;
        const beforeMonth = BigInt(days.slice(0, month - 1).reduce((sum, count) => sum + count, 0));
        const seconds = (beforeYear + beforeMonth + BigInt(day - 1) - 719162n) * 86400n +
            BigInt(hour * 3_600 + minute * 60 + second);
        const offsetHours = offset === 'Z' ? 0 : Number(offset.slice(1, 3));
        const offsetMinutePart = offset === 'Z' ? 0 : Number(offset.slice(4, 6));
        if (offsetHours > 23 || offsetMinutePart > 59)
            throw new Error('Expected a valid ISO offset.');
        const offsetMinutes = offset === 'Z' ? 0 : (offset[0] === '-' ? -1 : 1) *
            (offsetHours * 60 + offsetMinutePart);
        return (seconds - BigInt(offsetMinutes * 60)) * 1000000n + BigInt((fraction + '000000').slice(0, 6));
    };
    return parse(left) === parse(right);
}
//# sourceMappingURL=communications-system-notification-adapter.contract.js.map